/**
 * The juhuklient screens: the pipeline list, and one page per record.
 *
 * The file keeps its name because it is what the shell imports; the screens
 * themselves live next door, one responsibility per file.
 */
import { Route, Routes } from "react-router-dom";
import type { StaffUser } from "../../../lib/auth";
import { LeadDetail } from "./LeadDetail";
import { LeadsPage } from "./LeadsPage";

export function LeadsSection({ user }: { user: StaffUser }) {
  return (
    <Routes>
      <Route path="/" element={<LeadsPage user={user} />} />
      <Route path="/:id" element={<LeadDetail user={user} />} />
    </Routes>
  );
}
